import { Card, Flex, Grid, GridItem, Separator, Text } from '@chakra-ui/react';
import React from 'react';
import ContentCard from '../../../components/layout/ContentCard';
import EmailGraph from '../components/EmailGraph';
import { IEmailProcessingStats } from '../types';

interface EmailProcessingCardProps {
    emailProcessingStats: IEmailProcessingStats;
} 

const EmailProcessingCard = ({ emailProcessingStats }: EmailProcessingCardProps) => {
    return (
        <ContentCard
            header={
                <>
                    <Grid templateColumns="repeat(6, 1fr)">
                        <GridItem colSpan={3}>
                            <Card.Title fontSize='sm'>Email processing</Card.Title>
                        </GridItem>
                        <GridItem colSpan={2}>
                            <Card.Title fontSize='sm'>Total emails</Card.Title>
                        </GridItem>
                        <GridItem colSpan={1}>
                            <Card.Title fontSize='sm'>{emailProcessingStats?.totalEmails ?? 0}</Card.Title>
                        </GridItem>
                    </Grid>
                    <Separator />
                </>
            }
            width={566}
        >
            <Grid templateColumns="repeat(6, 1fr)">
                <GridItem colSpan={6}>
                    <EmailGraph width={263} emailProcessingStats={emailProcessingStats}/>
                </GridItem>
                {/* <GridItem colSpan={2}>
                </GridItem>
                <GridItem colSpan={1} alignContent='center'>
                    <Card.Title fontSize='sm'>469</Card.Title>
                </GridItem> */}
            </Grid>
        </ContentCard>
    )
}

export default EmailProcessingCard;